import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    qEn: 'What happens at the first visit?',
    qEs: '¿Qué pasa en la primera consulta?',
    aEn: 'We will review your medical history, discuss your weight loss goals, and determine if you are a candidate for surgery. You will meet Dr. Ailawadi and have the opportunity to ask questions.',
    aEs: 'Revisaremos tu historial médico, discutiremos tus objetivos de pérdida de peso y determinaremos si eres candidato para la cirugía. Conocerás al Dr. Ailawadi y tendrás la oportunidad de hacer preguntas.'
  }, {
    qEn: 'Am I a candidate?',
    qEs: '¿Soy candidato/a?',
    aEn: 'Candidacy depends on your BMI and related health conditions. Generally, a BMI over 40, or over 35 with related health issues, may qualify you. A full evaluation is needed.',
    aEs: 'La candidatura depende de tu IMC y condiciones de salud relacionadas. Generalmente, un IMC superior a 40, o superior a 35 con problemas de salud relacionados, puede calificarte. Se necesita una evaluación completa.'
  }, {
    qEn: 'What procedures do you offer?',
    qEs: '¿Qué procedimientos ofrecen?',
    aEn: 'We specialize in Sleeve Gastrectomy, Gastric Bypass, and Revisional Bariatric Surgery. We will discuss which option is best for your specific situation.',
    aEs: 'Nos especializamos en Manga Gástrica, Bypass Gástrico y Cirugía Bariátrica de Revisión. Discutiremos qué opción es mejor para tu situación específica.'
  }, {
    qEn: 'What are the risks?',
    qEs: '¿Cuáles son los riesgos?',
    aEn: 'As with any major surgery, there are risks including infection, bleeding, and reactions to anesthesia. We will discuss all specific risks in detail during your consultation.',
    aEs: 'Como con cualquier cirugía mayor, existen riesgos que incluyen infección, sangrado y reacciones a la anestesia. Discutiremos todos los riesgos específicos en detalle durante tu consulta.'
  }, {
    qEn: 'How long is recovery?',
    qEs: '¿Cuánto dura la recuperación?',
    aEn: 'Most patients return to work within 1-2 weeks, depending on the physical demands of their job. Full recovery varies by individual.',
    aEs: 'La mayoría de los pacientes regresan al trabajo en 1-2 semanas, dependiendo de las exigencias físicas de su trabajo. La recuperación completa varía según el individuo.'
  }, {
    qEn: 'Do you accept insurance?',
    qEs: '¿Aceptan seguro?',
    aEn: 'We accept most major insurance plans. Our team will help verify your benefits and guide you through the approval process.',
    aEs: 'Aceptamos la mayoría de los planes de seguro principales. Nuestro equipo ayudará a verificar tus beneficios y te guiará a través del proceso de aprobación.'
  }, {
    qEn: 'What lifestyle changes are needed?',
    qEs: '¿Qué cambios de hábitos se requieren?',
    aEn: 'Surgery is a tool that works best with lifelong changes in diet and exercise. We provide guidance on nutrition and habits for long-term success.',
    aEs: 'La cirugía es una herramienta que funciona mejor con cambios de por vida en la dieta y el ejercicio. Brindamos orientación sobre nutrición y hábitos para el éxito a largo plazo.'
  }, {
    qEn: 'How do I schedule?',
    qEs: '¿Cómo agendo?',
    aEn: 'You can schedule by calling our office at 484-408-4100 or by using the contact form on this page.',
    aEs: 'Puedes agendar llamando a nuestra oficina al 484-408-4100 o usando el formulario de contacto en esta página.'
  }, {
    qEn: 'What should I bring?',
    qEs: '¿Qué debo llevar?',
    aEn: 'Please bring your photo ID, insurance card, and a list of current medications. If you have recent medical records, bringing those can be helpful.',
    aEs: 'Por favor trae tu identificación con foto, tarjeta de seguro y una lista de medicamentos actuales. Si tienes registros médicos recientes, traerlos puede ser útil.'
  }];
  return <section className="py-16 bg-slate-50" data-id="element-40">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-43">
            {t('Frequently Asked Questions', 'Preguntas frecuentes')}
          </h2>
        </div>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-slate-200 overflow-hidden" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-5 text-left focus:outline-none" data-id="element-46">
                <span className="font-semibold text-slate-900 text-lg" data-id="element-47">
                  {t(faq.qEn, faq.qEs)}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-teal-600 flex-shrink-0 ml-4" data-id="element-48" /> : <ChevronDown className="w-5 h-5 text-slate-400 flex-shrink-0 ml-4" data-id="element-49" />}
              </button>

              <AnimatePresence data-id="element-50">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-51">
                    <div className="px-5 pb-5 text-slate-600 leading-relaxed border-t border-slate-100 pt-3" data-id="element-52">
                      {t(faq.aEn, faq.aEs)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}